import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, InfoTooltip } from 'components/v3'; // Assuming Checkbox is also in v3
import { layouts } from 'config/constants';
import { useStyles } from './FormCheckbox.styles';
import useMediaQuery from 'utils/mediaQueries';

const FormCheckbox = React.forwardRef(
  ({ value, content, onChange, disabled, tooltip, 'data-test': dataTest, layout = layouts.default, ...props }, ref) => {
    const { classes } = useStyles();
    const isMobile = useMediaQuery();

    return (
      <div className={classes.wrapper} data-test={dataTest ? `${dataTest}-wrapper` : undefined}>
        <Checkbox
          checked={value}
          onChange={onChange}
          disabled={disabled}
          inputRef={ref}
          content={content}
          layout={layout}
          data-test={dataTest}
          {...props}
        />
        {tooltip && (
          <span className={classes.tooltipSpan}>
            <InfoTooltip text={tooltip} clickableWhenMobile={isMobile} layout={layout} />
          </span>
        )}
      </div>
    );
  }
);

FormCheckbox.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func,
  layout: PropTypes.string,
  disabled: PropTypes.bool,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  content: PropTypes.string,
  helperText: PropTypes.string,
  'data-test': PropTypes.string
};

export default FormCheckbox;
